import { render, staticRenderFns } from "./user-selector.vue?vue&type=template&id=3bbd90bc&scoped=true"
import script from "./user-selector.vue?vue&type=script&lang=ts"
export * from "./user-selector.vue?vue&type=script&lang=ts"
import style0 from "./user-selector.vue?vue&type=style&index=0&id=3bbd90bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd90bc",
  null
  
)

export default component.exports